import { render, staticRenderFns } from "./approve.vue?vue&type=template&id=e296f460&scoped=true"
import script from "./approve.vue?vue&type=script&lang=js"
export * from "./approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e296f460",
  null
  
)

export default component.exports